import isOttoDomain from '../Helpers/isOttoDomain';

export default isOttoDomain ? '1111 Lincoln Road, Suite 657, Miami Beach, FL 33139' : '25 SE 2nd Ave Ste 550 PMB 177, Miami, FL 33131';
